export const environment = {
  production: false,
  envType: 'DEVELOPMENT',
  isFullOnline: true,
  caisseApiUrl: 'https://devgestion.quiditmiam.fr/api',
  title: 'Caisse Collective - Développement',
  buildDate: "2026-09-22T10:09:09",
  lastPipeline: "6601",
  version: "0.0.0",
  sentryDsn: '',
};
